<app-icon class="warning-icon" hoverColor="tertiary" color="tertiary">warning</app-icon>
